import { createStyles, Stack } from "@mantine/core";
import React from "react";
import { tokens } from "@blurb/codex-react";
import { Label, Body } from "./Typography";
import { CopyableRow } from "./CopyableRow";

const useStyles = createStyles({
  content: {
    color: tokens.color.semantic.text.bold,
    gap: tokens.spacing[1],
  },
});

interface RpiTextFieldProps {
  label?: React.ReactNode;
  children: string | number;
  copyable?: boolean;
  size?: "sm" | "base";
}

export const RpiTextField: React.FC<RpiTextFieldProps> = ({ label, children, copyable, size }) => {
  const { classes } = useStyles();
  const iconSize = size === "sm" ? "base" : "xl";

  return (
    <Stack className={classes.content}>
      {label && <Label>{label}</Label>}
      {copyable ? (
        <CopyableRow value={String(children)} size={iconSize}>
          <Body size={size}>{children}</Body>
        </CopyableRow>
      ) : (
        <Body size={size}>{children}</Body>
      )}
    </Stack>
  );
};
